import { apiClient } from './client';

export async function getDiscounts(params = {}) {
  const { data } = await apiClient.get('/discounts', { params });
  return data;
}

export async function getDiscountStats() {
  const { data } = await apiClient.get('/discounts/stats');
  return data;
}

export async function getDiscount(id) {
  const { data } = await apiClient.get(`/discounts/${id}`);
  return data;
}

export async function createDiscount(body) {
  const { data } = await apiClient.post('/discounts', body);
  return data;
}

export async function updateDiscount(id, body) {
  const { data } = await apiClient.put(`/discounts/${id}`, body);
  return data;
}

export async function toggleDiscount(id) {
  const { data } = await apiClient.patch(`/discounts/${id}/toggle`);
  return data;
}

export async function deleteDiscount(id) {
  const { data } = await apiClient.delete(`/discounts/${id}`);
  return data;
}
